<template>
  <div>
    <corner
      ref="corner"
      :is-loading="false"
      :is-management-mode="false"
      :publishing="publishing"
      :corner-listing="corner"
      :corner-title="myAppName"
      :resource-path="resourcePath"
      :resource-item-path="resourceItemPath"
    />
    <Form />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Corner from "@/components/corner";
import RecordViews from "@/mixins/RecordViews";

export default {
  name: "CornerPublishing",
  mixins: [RecordViews],
  components: {
    Corner
  },
  beforeMount() {
    this.myAppName = this.$route.params.myAppName;
    this.resourcePath = this.$route.params.resource;
    this.resourceItemPath = this.$route.params.resourceItem;

    if (this.resourcePath) {
      console.log(
        `Title: ${this.myAppName} | Resource: ${this.resourcePath} | ResourceItem: ${this.resourceItemPath} `
      );
    }
  },
  mounted() {
    this.getCornerData();
    if (this.user && this.$refs.corner) {
      this.$refs.corner.getCollectedCornerPublishings();
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      listPublishings: "listings/listPublishings"
    }),
    publishing() {
      return this.corner ? this.corner.doc : null;
    }
  },
  methods: {
    handleNoCornerData() {
      this.$router.push("/");
    },
    getCornerData() {
      this.$store
        .dispatch("listings/getPublishingByMyAppName",
            {
              myAppName: this.myAppName
            }
        )
        .then(res => {
          if (Object.keys(res).length === 0) {
            this.handleNoCornerData();
          } else {
            this.corner = res;
            this.recordView(this.corner.id);

            //GET CREW
            if (res.doc.guides && res.doc.guides.length > 0) {
              res.doc.guides.forEach(guide => {});
            }
            //GET APPS
            if (res.doc.tools && res.doc.tools.length > 0) {
              res.doc.tools.forEach(tool => {
                //this.getTool(tool.toolId);
              });
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    recordView(publishingId) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "publishings",
        entityId: publishingId,
        feedbackType: "views",
        sessionId: this.checkSession("sessions")
      });
    },
    handleToggleShelfPublishing(data) {
      if (!this.user) {
        this.$bvModal.show("loginModal");
      } else {
        if (!this.isFollowed) {
          this.$store
            .dispatch("user/followBlogger", this.publishing.blogger)
            .then(() => {
              this.getCollectedCornerPublishings();
              console.log("Followed");
            });
        } else {
          this.$store
            .dispatch("user/unfollowBlogger", this.publishing.blogger)
            .then(() => {
              this.getCollectedCornerPublishings();
              console.log("Unfollowed");
            });
        }
      }
    }
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:title", content: this.blogTitle },
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.logo },
        { property: "og:title", content: this.blogTitle },
        { property: "og:site_name", content: "JourneyBinder" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: this.description }
      ]
    };
  },
  data() {
    return {
      corner: null,
      myAppName: null,
      resourcePath: null,
      resourceItemPath: null,
      collectedCorners: null
    };
  },
};
</script>
